import { createSlice } from '@reduxjs/toolkit';

import type { ModalTypes } from 'src/helper/shared-types';
import reducers from './reducers';
import type { VendorModalsInitialStateType } from './types';

export const INITIAL_MODAL_STATE: ModalTypes = { isVisible: false, extraProps: {} };

const initialState: VendorModalsInitialStateType = {
  materialModal: { isVisible: false, extraProps: { mode: '' } },
  otherActionModal: INITIAL_MODAL_STATE,
  startEnrouteModal: INITIAL_MODAL_STATE,
  contactInfoModal: INITIAL_MODAL_STATE,
  selectScheduleModal: INITIAL_MODAL_STATE,
  allIssuesClosedModal: INITIAL_MODAL_STATE,
  closeWorkOrderModal: INITIAL_MODAL_STATE,
  residentInfoModal: INITIAL_MODAL_STATE,
  quoteRemovalModal: INITIAL_MODAL_STATE,
  quoteTaskRemovalModal: INITIAL_MODAL_STATE,
  markAsPendingModal: INITIAL_MODAL_STATE,
  optionModal: INITIAL_MODAL_STATE,
  adjustElapsedTimeModal: INITIAL_MODAL_STATE,
  directionModal: INITIAL_MODAL_STATE,
  editQuoteReasonModal: INITIAL_MODAL_STATE,
};

const modals = createSlice({
  name: 'modals',
  initialState,
  reducers,
});

export const {
  toggleVendorModal,

  // Material Modal
  addWorkOrderMaterial,
  editWorkOrderMaterial,

  openAllIssuesClosedModal,
} = modals.actions;

export default modals.reducer;
